import { MeetingRecorder, MeetingRecorderStatus } from 'src/__generated__/graphql'

export function isActiveMeetingRecorder(meetingRecorder: Pick<MeetingRecorder, 'status'>) {
  const activeRecordingStates = [
    MeetingRecorderStatus.JoiningCall,
    MeetingRecorderStatus.InWaitingRoom,
    MeetingRecorderStatus.InMeetingNotRecording,
    MeetingRecorderStatus.InMeetingRecording,
    MeetingRecorderStatus.InMeetingPauseRequested,
    MeetingRecorderStatus.InMeetingPaused,
    MeetingRecorderStatus.InMeetingResumeRequested,
    MeetingRecorderStatus.InMeetingStopRequested,
    MeetingRecorderStatus.InvitedToMeeting,
  ]
  return activeRecordingStates.includes(meetingRecorder.status)
}

export function getActiveMeetingRecorders(meetingRecorders: Pick<MeetingRecorder, 'status'>[]) {
  return meetingRecorders.filter((recorder) => isActiveMeetingRecorder(recorder))
}

export function isFinishedMeetingRecorder(meetingRecorder: Pick<MeetingRecorder, 'status'>) {
  return meetingRecorder.status === MeetingRecorderStatus.Cancelled || meetingRecorder.status === MeetingRecorderStatus.Completed || meetingRecorder.status === MeetingRecorderStatus.Failed
}
